import React from 'react';
import Box from '@mui/material/Box';
import { LinearProgress } from '../../linear-progress';

export function LookupLoadingIndicator({ loading }: { loading: boolean }) {
  return (
    <Box sx={{ position: 'absolute', bottom: 1, left: 1, right: 1, height: 3, zIndex: 1, overflow: 'hidden', pointerElements: 'none' }}>
      <LinearProgress show={loading} />
    </Box>
  );
}
